/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UpdateWebhookGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type UpdateWebhookRequest = {
  webhookID: string;
  updateWebhook: components.UpdateWebhook;
};

export type UpdateWebhookResponse = {
  headers: { [k: string]: Array<string> };
  result: components.Webhook;
};

/** @internal */
export const UpdateWebhookGlobals$inboundSchema: z.ZodType<
  UpdateWebhookGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type UpdateWebhookGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const UpdateWebhookGlobals$outboundSchema: z.ZodType<
  UpdateWebhookGlobals$Outbound,
  z.ZodTypeDef,
  UpdateWebhookGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function updateWebhookGlobalsToJSON(
  updateWebhookGlobals: UpdateWebhookGlobals,
): string {
  return JSON.stringify(
    UpdateWebhookGlobals$outboundSchema.parse(updateWebhookGlobals),
  );
}
export function updateWebhookGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<UpdateWebhookGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateWebhookGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateWebhookGlobals' from JSON`,
  );
}

/** @internal */
export const UpdateWebhookRequest$inboundSchema: z.ZodType<
  UpdateWebhookRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  webhookID: z.string(),
  UpdateWebhook: components.UpdateWebhook$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "UpdateWebhook": "updateWebhook",
  });
});
/** @internal */
export type UpdateWebhookRequest$Outbound = {
  webhookID: string;
  UpdateWebhook: components.UpdateWebhook$Outbound;
};

/** @internal */
export const UpdateWebhookRequest$outboundSchema: z.ZodType<
  UpdateWebhookRequest$Outbound,
  z.ZodTypeDef,
  UpdateWebhookRequest
> = z.object({
  webhookID: z.string(),
  updateWebhook: components.UpdateWebhook$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    updateWebhook: "UpdateWebhook",
  });
});

export function updateWebhookRequestToJSON(
  updateWebhookRequest: UpdateWebhookRequest,
): string {
  return JSON.stringify(
    UpdateWebhookRequest$outboundSchema.parse(updateWebhookRequest),
  );
}
export function updateWebhookRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdateWebhookRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateWebhookRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateWebhookRequest' from JSON`,
  );
}

/** @internal */
export const UpdateWebhookResponse$inboundSchema: z.ZodType<
  UpdateWebhookResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.Webhook$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type UpdateWebhookResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.Webhook$Outbound;
};

/** @internal */
export const UpdateWebhookResponse$outboundSchema: z.ZodType<
  UpdateWebhookResponse$Outbound,
  z.ZodTypeDef,
  UpdateWebhookResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.Webhook$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function updateWebhookResponseToJSON(
  updateWebhookResponse: UpdateWebhookResponse,
): string {
  return JSON.stringify(
    UpdateWebhookResponse$outboundSchema.parse(updateWebhookResponse),
  );
}
export function updateWebhookResponseFromJSON(
  jsonString: string,
): SafeParseResult<UpdateWebhookResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateWebhookResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateWebhookResponse' from JSON`,
  );
}
